import React, { useEffect, useState } from "react";

const QuestionBank = () => {
    return (
        <section id="question-bank" style={{ padding: '80px 20px', background: '#f8f9fa' }}>
            <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
                <h2 style={{ fontSize: '2.5rem', fontWeight: '600', color: 'rgb(100, 19, 32)', textAlign: 'center', marginBottom: '50px', fontFamily: 'Lora' }}>QUESTION BANK</h2>

                <p style={{ color: '#333', marginBottom: '30px', textAlign: 'center' }}>
                    Access comprehensive question banks designed to enhance learning and exam preparation, across all subjects and grade levels.
                </p>

                <div className="row">
                    <div className="col-md-6 col-lg-3 mb-4">
                        <div style={{ background: 'white', padding: '30px', borderRadius: '10px', boxShadow: '0 5px 15px rgba(0,0,0,0.1)', textAlign: 'center', height: '200px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            <h4 style={{ fontSize: '1.2rem', color: 'rgb(100, 19, 32)', marginBottom: '15px', fontFamily: 'Lora' }}>Subject-wise Questions</h4>
                            <p className="tigps-main-question-bank-p">Comprehensive question sets for Mathematics, Science, English, and Social Studies.</p>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-3 mb-4">
                        <div style={{ background: 'white', padding: '30px', borderRadius: '10px', boxShadow: '0 5px 15px rgba(0,0,0,0.1)', textAlign: 'center', height: '200px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            <h4 style={{ fontSize: '1.2rem', color: 'rgb(100, 19, 32)', marginBottom: '15px', fontFamily: 'Lora' }}>Previous Year Papers</h4>
                            <p className="tigps-main-question-bank-p">Access to CBSE board examination papers from the previous years.</p>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-3 mb-4">
                        <div style={{ background: 'white', padding: '30px', borderRadius: '10px', boxShadow: '0 5px 15px rgba(0,0,0,0.1)', textAlign: 'center', height: '200px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            <h4 style={{ fontSize: '1.2rem', color: 'rgb(100, 19, 32)', marginBottom: '15px', fontFamily: 'Lora' }}>Mock Tests</h4>
                            <p className="tigps-main-question-bank-p">Regular practice tests, to assess progress and exam readiness.</p>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-3 mb-4">
                        <div style={{ background: 'white', padding: '30px', borderRadius: '10px', boxShadow: '0 5px 15px rgba(0,0,0,0.1)', textAlign: 'center', height: '200px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            <h4 style={{ fontSize: '1.2rem', color: 'rgb(100, 19, 32)', marginBottom: '15px', fontFamily: 'Lora' }}>Sample Papers</h4>
                            <p className="tigps-main-question-bank-p">CBSE-patterned sample papers, for effective exam preparation.</p>
                        </div>
                    </div>
                </div>

                <div style={{ textAlign: 'center', marginTop: '30px' }}>
                    <a
                        href="/question-bank"
                        rel="noopener noreferrer"
                        style={{
                            fontSize: "1.2rem",
                            fontWeight: "bold",
                            color: "rgb(100, 19, 32)",
                            fontFamily: "Lora",
                            cursor: "pointer",
                            textDecoration: "none"
                        }}
                    >
                        Click here to open the Question Bank
                    </a>
                </div>
            </div>
        </section>
    );
};

export default QuestionBank;
